import { Drawer, Spinner, Text, VStack, Portal, CloseButton } from '@chakra-ui/react';
import { useMeetingPacket } from '../../hooks/useLobbyDay'
import { lobbyAttachmentApi } from '../../lib/api'
import { PacketContent } from './PacketContent'

interface PacketPreviewDrawerProps {
  eventId: string
  meetingId: string | null
  onClose: () => void
}

/** "Preview packet as attendee" — renders exactly what the phone shows. */
export function PacketPreviewDrawer({ eventId, meetingId, onClose }: PacketPreviewDrawerProps) {
  const { data: packet, isLoading, error } = useMeetingPacket(meetingId ?? undefined)
  return (
    <Drawer.Root open={!!meetingId} placement='end' size='sm' onOpenChange={e => {
      if (!e.open) {
        onClose();
      }
    }}>
      <Portal>

        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.CloseTrigger asChild><CloseButton size="sm" /></Drawer.CloseTrigger>
            <Drawer.Header>
              {packet ? `${packet.legislatorName} · ${packet.startTime.slice(0, 5)}` : 'Packet preview'}
            </Drawer.Header>
            <Drawer.Body>
              {isLoading && <VStack py={12}><Spinner size="lg" color="accent" /></VStack>}
              {!!error && <Text color="red.500">Failed to load packet.</Text>}
              {packet && (
                <PacketContent
                  packet={packet}
                  attachmentHref={(id) => lobbyAttachmentApi.fileUrl(eventId, id)}
                />
              )}
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>

      </Portal>
    </Drawer.Root>
  );
}
